export interface PollOptions {
  intervalMs: number;
  attempts: number;
  // Checked before every probe; once true the poll stops and returns false.
  isCancelled: () => boolean;
}

/**
 * Calls `check` until it returns true, waiting `intervalMs` between calls,
 * at most `attempts` + 1 times. Returns false when the attempts run out or
 * the poll is cancelled.
 */
export const pollUntil = async (
  check: () => Promise<boolean>,
  { intervalMs, attempts, isCancelled }: PollOptions
): Promise<boolean> => {
  for (let attempt = 0; attempt <= attempts; attempt += 1) {
    if (isCancelled()) {
      return false;
    }
    // eslint-disable-next-line no-await-in-loop
    if (await check()) {
      return !isCancelled();
    }
    if (attempt < attempts) {
      // eslint-disable-next-line no-await-in-loop
      await new Promise(resolve => {
        setTimeout(resolve, intervalMs);
      });
    }
  }
  return false;
};
